module.exports = __webpack_public_path__ + "static/media/picture-9@2x.028dc2f9.png";